<template>
  <div class="">
    <NuxtRouteAnnouncer/>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </div>
</template>
<script lang="ts" setup>
</script>
<style>
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: opacity .15s, transform .1s;
    transform: translateY(-50px);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(0);
}
</style>